import { toRGB } from '@/utils/colors';
import { getGradientObject } from '@/utils/gradient';
export const FALLBACK_COLOR = 'rgba(255, 255, 255, 1)';
export const FALLBACK_GRADIENT_COLOR = 'linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)';
export function getChangedColor(srcValue, selectedColor, defaults) {
  // Detect if color changed from solid to gradient
  const currentColorInfo = getGradientObject(selectedColor || '');
  const changedColorInfo = getGradientObject(srcValue || '');
  const isColorTypeChanged = currentColorInfo.isGradient !== changedColorInfo.isGradient; // Get the default color based on the new color type

  const defaultColor = changedColorInfo.isGradient ? (defaults === null || defaults === void 0 ? void 0 : defaults.gradient) ?? FALLBACK_GRADIENT_COLOR : (defaults === null || defaults === void 0 ? void 0 : defaults.solid) ?? FALLBACK_COLOR;
  return isColorTypeChanged ? defaultColor : srcValue || '';
}
export function convertPalletToRGB(pallet, defaultColors) {
  if (!(pallet !== null && pallet !== void 0 && pallet.length)) return defaultColors;
  return pallet.map(color => toRGB(color));
}
export function withColorPresets(pallet, colorPresets) {
  if (!(pallet !== null && pallet !== void 0 && pallet.length)) return colorPresets;
  return [...pallet, ...colorPresets];
}